import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function AmazonRedshiftIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box as="g" clipPath={`url(#${`redshift-a-${id}`})`}>
        <Box as="path" fill="#205B97" d="m10 15.293 7.605 1.813V2.855L10 4.667v10.625Z" />
        <Box
          as="path"
          fill="#5193CE"
          d="m17.605 2.855 1.45.723v12.797l-1.45.723V2.855ZM10 15.293l-7.605 1.809V2.855L10 4.668v10.625Z"
        />
        <Box as="path" fill="#205B97" d="m2.395 2.855-1.45.727v12.797l1.45.723V2.855Z" />
        <Box as="path" fill="#5193CE" d="m11.934 20 2.898-1.45V1.45L11.934 0l-.887 9.496L11.934 20Z" />
        <Box as="path" fill="#205B97" d="m8.066 20-2.898-1.45V1.45L8.066 0l.887 9.496L8.066 20Z" />
        <Box as="path" fill="#2E73B7" d="M8.066 0h3.903v19.96H8.066V0Z" />
      </Box>
      <Box as="defs">
        <clipPath id={`redshift-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
